// import React from "@types/react";

import SectionHandler from "./SectionHandler";
import React from "react";
import CheckoutSection from "./CheckoutSection";
import {ActionPageCreate, StatePageCreate} from "../PageCreate";

class DetailsSection extends SectionHandler {

    constructor(state: StatePageCreate, dispatch: React.Dispatch<ActionPageCreate>) {
        super(state, dispatch);
        console.log("DetailsSection");
        // this.checkSignIn();
    }

    nextHandler() {
        let subdomain = this.subdomain();
        return this.state.user && subdomain && this.state.toggles.has('details-complete') ? (new CheckoutSection(this.state, this.dispatch)) : null;
    }

    domainGenerated = () => {
        let subdomain = this.subdomain(this.state.name); // no need to use this.state.subdomain
        return `${subdomain || '***'}.${Constants.get('HOST_BASE') || 'no-domain.com'}`;
    }

    signedIn() {
        return <>
        </>;
    }

    displayNameSection() {
        return <>
            <div className="row my-3">
                <div className="md-12 text-center">
                    <h2>
                        {this.state.name ? `${this.state.name} Loves Wang` : "I Love Wang"}
                    </h2>
                </div>
            </div>
            {this.domainGenerated() && <div className="row my-1">
                <div className="col-md-12 text-center">
                    {this.domainGenerated()}
                </div>
            </div>}
            <div className="row my-3">
                <div className="md-12 text-center">
                    <button className={"btn btn-secondary btn-lg"}
                            onClick={() => this.dispatch({type: 'toggle', payload: 'details-complete'})}>
                        Edit
                    </button>
                </div>
            </div>
        </>
    }

    editNameSection() {
        return <>
            <div className="row mt-4">
                <div className="md-12">
                    <h2 className={"text-center"}>
                        Your Details
                    </h2>
                </div>
            </div>
            {this.state.user && this.signIn.signedIn()}
            <div className="row my-2">
                <div className="input-group mb-3 col-md-6 col-md-offset-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="inputGroup-name">Name</span>
                    </div>
                    <input type="text" className="form-control" aria-label="Default"
                           aria-describedby="inputGroup-name"
                           onChange={(e) => {
                               this.dispatch({
                                   type: 'set-name',
                                   name: e.target.value,
                                   subdomain: this.subdomain(e.target.value)
                               })
                           }}
                           value={this.state.name}
                    />
                </div>
            </div>
            {this.domainGenerated() && <div className="row my-1">
                <div className="col-md-12 text-center">
                    {this.domainGenerated()}
                </div>
            </div>}
            {this.state.user ? this.signedIn() : this.signIn.handle() }
            {this.state.user && this.subdomain(this.state.name) &&
                <div className="row my-3">
                    <div className="md-12 text-center">
                        <button className={"btn btn-primary btn-lg"}
                                onClick={() => {this.state.pageCreator.reset(); this.dispatch({type: 'toggle', payload: 'details-complete'})}}>
                            Continue
                        </button>
                    </div>
                </div>
            }
        </>
    }

    handle() {
        return <>
            {this.state.toggles.has('details-complete') ? this.displayNameSection() : this.editNameSection()}
        </>
    }


}

export default DetailsSection;
